import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { appRoutePaths } from '../../components/Root/navigation';

const catalogIndexRouteRef = createRouteRef({
  aliasFor: 'catalog.catalogIndex',
});

const catalogPage = PageBlueprint.make({
  name: 'driveline-index',
  params: {
    path: appRoutePaths.catalog,
    routeRef: catalogIndexRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/catalog/CustomCatalogIndex').then(module => (
        <module.CustomCatalogPage />
      )),
  },
});

export const catalogPageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPage],
});
